module.exports = __webpack_public_path__ + "static/testrail-ead42adeb8d9df2fd7e2dda468bd4438.png";